var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE0A",
    d: "m18.3008 15.4707-7.0723-12.086Q10.7636 2.6875 10 2.6875q-.7637 0-1.2285.6973L1.6992 15.4707q-.3984.7305 0 1.3945.3653.6641 1.2285.6973h14.1445q.8634-.0332 1.2286-.6973.3984-.664 0-1.3945M9.2031 7.2031q.0664-.7305.7969-.7969.7305.0665.7969.7969v4.25q-.0665.7306-.7637.7969-.332 0-.5645-.2324-.2655-.2325-.2656-.5645zM10 15.4375q-.4317 0-.7304-.2989-.299-.2987-.2989-.7304 0-.4648.2988-.7636.2988-.299.7305-.2989.4316 0 .7304.2989.299.2988.2989.7636 0 .4317-.2989.7304-.2988.299-.7304.2989"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-tip.cf57a8519767f7d908b1d20fe7cbb0a9.svg";